/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoringTimeAndPackageHistoryPeriodDTO
 */
export interface MonitoringTimeAndPackageHistoryPeriodDTO {
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimeAndPackageHistoryPeriodDTO
     */
    usedSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimeAndPackageHistoryPeriodDTO
     */
    topUpSeconds: number;
    /**
     * 
     * @type {Date}
     * @memberof MonitoringTimeAndPackageHistoryPeriodDTO
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof MonitoringTimeAndPackageHistoryPeriodDTO
     */
    periodEnd: Date;
}

/**
 * Check if a given object implements the MonitoringTimeAndPackageHistoryPeriodDTO interface.
 */
export function instanceOfMonitoringTimeAndPackageHistoryPeriodDTO(value: object): value is MonitoringTimeAndPackageHistoryPeriodDTO {
    if (!('usedSeconds' in value) || value['usedSeconds'] === undefined) return false;
    if (!('topUpSeconds' in value) || value['topUpSeconds'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    return true;
}

export function MonitoringTimeAndPackageHistoryPeriodDTOFromJSON(json: any): MonitoringTimeAndPackageHistoryPeriodDTO {
    return MonitoringTimeAndPackageHistoryPeriodDTOFromJSONTyped(json, false);
}

export function MonitoringTimeAndPackageHistoryPeriodDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTimeAndPackageHistoryPeriodDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'usedSeconds': json['usedSeconds'],
        'topUpSeconds': json['topUpSeconds'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
    };
}

export function MonitoringTimeAndPackageHistoryPeriodDTOToJSON(value?: MonitoringTimeAndPackageHistoryPeriodDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'usedSeconds': value['usedSeconds'],
        'topUpSeconds': value['topUpSeconds'],
        'periodStart': ((value['periodStart']).toISOString()),
        'periodEnd': ((value['periodEnd']).toISOString()),
    };
}

